// project imports
import dashboard from './dashboard';
import fleetRealtimeTracking from './fleetRealtimeTracking';
import fuelConsumptionMonitoring from './fuelConsumptionMonitoring';
import driverManagement from './driverManagement';
import videoMonitoring from './videoMonitoring';
import maintenaceManagement from './maintenanceManagement';
import p2hInspection from './p2hInspection';
import tyreManagement from './tyreManagement';
import reportAndNotification from './reportAndNotification';
import masterData from './masterData';
// import settings from './settings';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [
    dashboard,
    fleetRealtimeTracking,
    fuelConsumptionMonitoring,
    driverManagement,
    videoMonitoring,
    maintenaceManagement,
    p2hInspection,
    tyreManagement,
    reportAndNotification,
    masterData
    // settings
  ]
};

export default menuItems;
